

import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useSignInCheckUserMutation } from '../store/api/userAuthApi';

const PrivateRoute = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [signInCheckUser] = useSignInCheckUserMutation();

  useEffect(() => {
    const checkAuthentication = async () => {
      const userData = localStorage.getItem("UserData");

      if (!userData) {
        setIsLoading(false);
        setIsAuthenticated(false);

        return;
      }
      let parsedUser;
      try {
        parsedUser = JSON.parse(userData);
      } catch (error) {
        localStorage.removeItem("UserData");
        return;
      }

      if (!parsedUser || typeof parsedUser !== 'object' || !parsedUser.id || !parsedUser.name || !parsedUser.phone) {
        localStorage.removeItem("UserData");
        setIsLoading(false);
        setIsAuthenticated(false);
        return;
      }


      try {
        const response = await signInCheckUser({
          username: "",
          password: "",
          name: parsedUser.name,
          phone: parsedUser.phone,
        });

        if (response.data.status === 200) {
          setIsAuthenticated(true);
        } else {
          localStorage.removeItem("UserData");
        }
      } catch (error) {
        console.error("Error signing in user:", error);
      } finally {
        setIsLoading(false);
      }
    };

    checkAuthentication();
  }, [signInCheckUser]);

 


  if (isLoading) {
    return <div> </div>;
  }

  if (!isAuthenticated) {
    return <Navigate to="/signin" />;
  }

  return children;
};

export default PrivateRoute;
